import { useInjection } from 'inversify-react';
import { type RolesService, RolesServiceIdentifier } from '@shared/types/mobx/services/roles';
import { ATTACH_BUTTON_ALLOWED_ROLES } from '@shared/constants/SupportedUserRoles';

/**
 * OSI-808 п.7: показывать ли кнопку «Прикрепить» (импорт Excel) текущему пользователю.
 * Разрешены только OPERATOR / ADMIN / MAIN_OPERATOR (см. ATTACH_BUTTON_ALLOWED_ROLES).
 *
 * ПОЧЕМУ ПРОВЕРЯЕМ МАССИВ roles, А НЕ ВЫБРАННУЮ РОЛЬ currentRole.
 * currentRole проставляется ТОЛЬКО на экране выбора роли, а он фильтрует роли по
 * SUPPORTED_USER_ROLES = ['CHAIRMAN','ABONENT','OPERATOR','NOTARIUS']
 * (widgets/selectRole/model/SelectRoleViewModel.ts). ADMIN и MAIN_OPERATOR в этот список
 * не входят и currentRole ими стать не может в принципе. При этом у реальных
 * админов/операторов рядом с ADMIN/OPERATOR обычно висит ещё и CHAIRMAN — выбрав на входе
 * «Председатель», такой пользователь получил бы currentRole='CHAIRMAN' и потерял кнопку.
 * Поэтому источник истины — массив всех ролей пользователя. Это же поведение у уже
 * существующих гейтов admin/operator: RolesService.isHasAdminRole / isHasOperatorRole
 * (widgets/osi/accounts/model/viewModel.ts, widgets/osi/info/model/viewModel.ts,
 * features/osi/accruals/serviceGroupManagement).
 *
 * ВАЖНО: читается observable-поле RolesService.roles, поэтому вызывающий компонент обязан быть
 * observer'ом — иначе после догидрации persist-store кнопка не перерисуется.
 * Оба текущих потребителя (ImportAbonentsButton, AttachSaldoButton) уже обёрнуты в observer.
 */
export const useCanAttach = (): boolean => {
  const rolesModule = useInjection<RolesService>(RolesServiceIdentifier);

  return rolesModule.roles.some((r) => ATTACH_BUTTON_ALLOWED_ROLES.has(r.role));
};
